/**
 * Moldura-guia animada do viewfinder.
 * 4 cantos + scanline (respeita prefers-reduced-motion).
 */
export function ScanGuideFrame() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        top: '22%',
        left: '8%',
        right: '8%',
        bottom: '28%',
        pointerEvents: 'none',
        zIndex: 5,
      }}
    >
      {(
        [
          ['top', 'left', '10px 0 0 0'],
          ['top', 'right', '0 10px 0 0'],
          ['bottom', 'left', '0 0 0 10px'],
          ['bottom', 'right', '0 0 10px 0'],
        ] as const
      ).map(([v, h, br], i) => (
        <span
          key={i}
          style={{
            position: 'absolute',
            [v]: -2,
            [h]: -2,
            width: 28,
            height: 28,
            borderTop: v === 'top' ? '3px solid var(--mint)' : 'none',
            borderBottom: v === 'bottom' ? '3px solid var(--mint)' : 'none',
            borderLeft: h === 'left' ? '3px solid var(--mint)' : 'none',
            borderRight: h === 'right' ? '3px solid var(--mint)' : 'none',
            borderRadius: br,
          }}
        />
      ))}

      <div className="scan-line" aria-hidden="true" />

      <style>{`
        .scan-line {
          position: absolute; top: 0; left: 0; right: 0;
          height: 2px; background: var(--mint); opacity: 0.75;
          box-shadow: 0 0 10px var(--mint);
          animation: scanline 2s linear infinite;
        }
        @keyframes scanline { 0% { top: 0%; } 100% { top: 100%; } }
        @media (prefers-reduced-motion: reduce) { .scan-line { animation: none; top: 50%; } }
      `}</style>
    </div>
  );
}
